import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalLeadAccepted = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> accepted lead
    </Box>
  );
};

export default SabalLeadAccepted;
